'use client'
import { SvgLocation } from '@/components/ui/icons'
import { useActiveCohort } from '@/hooks/activeCohort'
import { useIsLatinAmerica } from '@/hooks/useIsLatinAmerica'

export function AboutHero() {
  const { cohort, isLoading } = useActiveCohort()

  return (
    <div className="">
      <div className="flex flex-col sm:flex-row justify-between items-start gap-8 sm:gap-4 mt-16 mx-auto max-w-7xl px-6 lg:px-8">
        <div className="uppercase about-title w-full sm:w-2/3 leading-[50px] sm:leading-[90px] font-[800] text-white ">
          We Transform<br></br> AI Concepts
        </div>
        <div className="flex flex-col gap-6  w-full sm:w-1/3 ">
          <div className="text-[20px] font-[400] text-[#E2E6F3] ">
            AI Forge is an intensive 12-week hybrid (online + in person)
            incubator, accelerating AI company creation for real-world problem
            solving.
          </div>
          <div className="text-[20px] font-[400] flex items-center gap-4 text-[#E2E6F3] ">
            <SvgLocation stroke={'#E2E6F3'} /> [ London ]
          </div>
          <div className="flex justify-end mt-16">
            <svg
              width="72"
              height="72"
              viewBox="0 0 72 72"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_bi_4636_27251)">
                <rect
                  width="72"
                  height="72"
                  rx="36"
                  fill="#3F609F"
                  fill-opacity="0.18"
                />
                <g filter="url(#filter1_i_4636_27251)">
                  <circle
                    cx="36"
                    cy="36"
                    r="29"
                    fill="#40557D"
                    fill-opacity="0.16"
                  />
                </g>
                <g filter="url(#filter2_i_4636_27251)">
                  <circle
                    cx="36"
                    cy="36"
                    r="21"
                    fill="#3A4A69"
                    fill-opacity="0.27"
                  />
                </g>
                <path
                  d="M29.1828 38.2139C29.1828 38.0399 29.2528 37.8659 29.4028 37.7285C29.6928 37.4629 30.1728 37.4629 30.4628 37.7285L36.0028 42.8021L41.5428 37.7285C41.8328 37.4629 42.3128 37.4629 42.6028 37.7285C42.8928 37.9941 42.8928 38.4337 42.6028 38.6992L36.5328 44.2582C36.2428 44.5238 35.7628 44.5238 35.4728 44.2582L29.4028 38.6992C29.2528 38.5619 29.1828 38.3879 29.1828 38.2139Z"
                  fill="#155EEF"
                />
                <path
                  d="M35.25 43.6184L35.25 28.2054C35.25 27.8299 35.59 27.5185 36 27.5185C36.41 27.5185 36.75 27.8299 36.75 28.2054L36.75 43.6184C36.75 43.9939 36.41 44.3053 36 44.3053C35.59 44.3053 35.25 43.9939 35.25 43.6184Z"
                  fill="#155EEF"
                />
              </g>
              <defs>
                <filter
                  id="filter0_bi_4636_27251"
                  x="-50"
                  y="-50"
                  width="172"
                  height="172"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="25" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_4636_27251"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_4636_27251"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="5" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.470179 0 0 0 0 0.585826 0 0 0 0 0.883203 0 0 0 0.11 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_4636_27251"
                  />
                </filter>
                <filter
                  id="filter1_i_4636_27251"
                  x="7"
                  y="7"
                  width="58"
                  height="58"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="4" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.470588 0 0 0 0 0.584314 0 0 0 0 0.882353 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_4636_27251"
                  />
                </filter>
                <filter
                  id="filter2_i_4636_27251"
                  x="15"
                  y="15"
                  width="42"
                  height="42"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="4" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.470588 0 0 0 0 0.584314 0 0 0 0 0.882353 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_4636_27251"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>

      <div className="pt-0 sm:pt-16 pb-16 flex justify-center relative flex-col  items-center">
        <img src="/aiorge-text.png" className="absolute top-0 " />
        {/* <img
          src="/about-hero.webp"
          className="object-cover w-[700.2px] h-[438.38px] sm:w-[1402.2px] sm:h-[876.38px]  "
        /> */}
        <video
          autoPlay
          loop
          muted
          // className="absolute -z-10 w-screen h-screen object-cover inset-0"
          className="object-cover w-[700.2px] h-[438.38px] sm:w-[1402.2px] sm:h-[876.38px]  "
        >
          <source src="/hero-about.mp4" type="video/mp4" />
        </video>
        <img src="/incubator.png" className="absolute bottom-0 " />
      </div>

      <p className="text-center text-[16px] font-semibold leading-[24px] text-[#155EEF] mt-12">
        How We Do it
      </p>
      <p className="text-[36px] font-semibold leading-[44px] text-[#fff] text-center my-2">
        Mapping the AI Forge Process
      </p>
      <p className="text-[#98A2B3] text-[20px] font-normal leading-[30px] text-center my-4">
        The AI Forge journey, tracing the path from your initial application to
        launching a thriving startup.
      </p>
      <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-14">
        <div
          className={`grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-5 justify-center justify-items-center`}
        >
          <div
            style={{
              border: '1px solid #1C1F22',
              background:
                'linear-gradient(130.39deg, #0055FF 0%, #15A6EF 91.25%)',
            }}
            className={`px-[32px] py-[32px] flex flex-col justify-between about-card rounded-[16px] border border-[#424242] justify-self-center`}
          >
            <div>
              <div className="w-[48px] h-[48px] flex justify-center items-center border border-white rounded-lg mb-14">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.05 19.4201C12.51 19.4201 11.94 19.3701 11.32 19.2701L6.62999 18.5301C5.14999 18.3001 4.00999 17.8901 3.15999 17.2901C0.969987 15.7701 1.09999 13.1601 1.37999 11.3301L2.11999 6.64005C2.79999 2.34005 5.01999 0.730051 9.31999 1.40005L14.01 2.14005C16.22 2.49005 19.19 3.38005 19.38 7.11005C19.42 7.75005 19.38 8.48005 19.24 9.34005L18.51 14.0301C17.93 17.7001 16.22 19.4201 13.05 19.4201ZM7.52999 2.75005C5.14999 2.75005 4.06999 3.96005 3.59999 6.88005L2.85999 11.5701C2.39999 14.5201 3.23999 15.5201 4.01999 16.0701C4.67999 16.5401 5.60999 16.8601 6.85999 17.0501L11.55 17.7901C15.04 18.3401 16.48 17.2901 17.03 13.7901L17.76 9.10005C17.88 8.35005 17.92 7.72005 17.88 7.19005V7.18005C17.77 5.08005 16.58 4.05005 13.77 3.61005L9.08999 2.88005C8.50999 2.79005 7.99999 2.75005 7.52999 2.75005Z"
                    fill="white"
                  />
                  <path
                    d="M14.6798 22.75C13.8298 22.75 12.8698 22.57 11.7598 22.2L7.24976 20.7C4.67976 19.8499 3.28976 18.6299 2.86976 16.8499C2.79976 16.5499 2.91976 16.2299 3.17976 16.0599C3.43976 15.8899 3.77976 15.8899 4.02976 16.0699C4.68976 16.5399 5.60976 16.8599 6.85976 17.0499L11.5498 17.79C15.0398 18.34 16.4798 17.2899 17.0298 13.7899L17.7598 9.09995C17.8798 8.34995 17.9198 7.71995 17.8798 7.18995C17.8698 6.92995 17.9998 6.66995 18.2298 6.51995C18.4598 6.36995 18.7498 6.35995 18.9898 6.48995C21.6698 7.91995 22.3798 10.2099 21.2198 13.7099L19.7198 18.2199C19.0098 20.3399 18.0798 21.64 16.7798 22.29C16.1498 22.6 15.4598 22.75 14.6798 22.75ZM5.72976 18.36C6.20976 18.6799 6.84976 18.99 7.71976 19.28L12.2298 20.78C13.9498 21.3499 15.1798 21.4 16.0998 20.95C17.0198 20.49 17.7198 19.4699 18.2898 17.7499L19.7898 13.2399C20.6098 10.7599 20.2898 9.43995 19.3398 8.54995C19.3198 8.79995 19.2798 9.05995 19.2398 9.33995L18.5098 14.0299C17.8298 18.33 15.6098 19.9399 11.3098 19.28L6.61976 18.54C6.30976 18.4799 6.00976 18.42 5.72976 18.36Z"
                    fill="white"
                  />
                  <path
                    d="M8.24 9.71999C6.87 9.71999 5.75 8.59999 5.75 7.22999C5.75 5.85999 6.87 4.73999 8.24 4.73999C9.61 4.73999 10.73 5.85999 10.73 7.22999C10.73 8.59999 9.61 9.71999 8.24 9.71999ZM8.24 6.24999C7.7 6.24999 7.25 6.68999 7.25 7.23999C7.25 7.78999 7.69 8.22999 8.24 8.22999C8.78 8.22999 9.23 7.78999 9.23 7.23999C9.23 6.68999 8.78 6.24999 8.24 6.24999Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p className="text-[20px] font-semibold leading-[30px]  text-[#fff] h-[80px]">
                Application Stage
                <p className="text-white opacity-[.80] text-[16px] font-normal leading-[24px]">
                  Application Deadline: {cohort?.deadline || ''}
                </p>
              </p>
              <p className="text-white opacity-[.80] text-[16px] font-normal leading-[24px] mb-5">
                Over 500 applicants compete for a spot in each AI Forge cohort,
                setting the stage for a highly competitive process.
              </p>
            </div>
            <div className="flex items-end justify-between w-full  ">
              <svg
                width="58"
                height="8"
                viewBox="0 0 58 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="30" height="8" rx="4" fill="#00D5FF" />
                <circle cx="40" cy="4" r="4" fill="#D9D9D9" />
                <circle cx="54" cy="4" r="4" fill="#D9D9D9" />
              </svg>
              <div
                className="p-6 gap-2.5 w-auto w-card h-card bg-white bg-opacity-[0.22] border border-[rgba(255,255,255,0.1)] rounded-[24px] shadow-[inset_0_0_10px_rgba(185,225,254,0.25)]"
                style={{ backdropFilter: 'blur(14.5px)' }}
              >
                <div className="text-white">Average Applications</div>
                <div>
                  <span className="text-white text-[20px] font-[600] ">
                    500
                  </span>{' '}
                  <span className="text-white text-sm font-[500] ">
                    for each cohort
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-800 bg-opacity-20  pt-[32px] flex flex-col justify-between  about-card rounded-[16px] border border-[#424242] justify-self-center">
            <div className="px-[32px]">
              <div className="bg-blue-500 bg-opacity-20 w-[48px] h-[48px] flex justify-center items-center border border-[#155EEF] rounded-lg mb-14">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.5 18.75C3.09 18.75 2.75 18.41 2.75 18V7C2.75 2.59 4.09 1.25 8.5 1.25H15.5C19.91 1.25 21.25 2.59 21.25 7V17C21.25 17.16 21.25 17.31 21.24 17.47C21.21 17.88 20.84 18.2 20.44 18.17C20.03 18.14 19.71 17.78 19.74 17.37C19.75 17.25 19.75 17.12 19.75 17V7C19.75 3.43 19.08 2.75 15.5 2.75H8.5C4.92 2.75 4.25 3.43 4.25 7V18C4.25 18.41 3.91 18.75 3.5 18.75Z"
                    fill="white"
                  />
                  <path
                    d="M17 22.75H7C4.66 22.75 2.75 20.84 2.75 18.5V17.85C2.75 15.86 4.37 14.25 6.35 14.25H20.5C20.91 14.25 21.25 14.59 21.25 15V18.5C21.25 20.84 19.34 22.75 17 22.75ZM6.35 15.75C5.19 15.75 4.25 16.69 4.25 17.85V18.5C4.25 20.02 5.48 21.25 7 21.25H17C18.52 21.25 19.75 20.02 19.75 18.5V15.75H6.35Z"
                    fill="white"
                  />
                  <path
                    d="M16 7.75H8C7.59 7.75 7.25 7.41 7.25 7C7.25 6.59 7.59 6.25 8 6.25H16C16.41 6.25 16.75 6.59 16.75 7C16.75 7.41 16.41 7.75 16 7.75Z"
                    fill="white"
                  />
                  <path
                    d="M13 11.25H8C7.59 11.25 7.25 10.91 7.25 10.5C7.25 10.09 7.59 9.75 8 9.75H13C13.41 9.75 13.75 10.09 13.75 10.5C13.75 10.91 13.41 11.25 13 11.25Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p className="text-[20px] font-semibold leading-[30px]  text-[#fff] h-[80px]">
                Pre Program Selection
                <p className="text-[#98A2B3] text-[16px] font-normal leading-[24px]">
                  {cohort?.start_date}
                </p>
              </p>
              <p className="text-[#98A2B3] text-[16px] font-normal leading-[24px] mb-5">
                40 of these applicants are carefully selected for the
                pre-program stage, identifying startups with promising AI
                concepts.
              </p>
            </div>
            <div
              className="flex items-end justify-between w-full h-[266px] rounded-bl-[16px] rounded-br-[16px] p-[32px] "
              style={{
                background:
                  'linear-gradient(113.44deg, #15A6EF 9.37%, #7B41F7 93.56%) ',
              }}
            >
              <svg
                width="58"
                height="8"
                viewBox="0 0 58 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="4" cy="4" r="4" fill="#D9D9D9" />
                <rect x="14" width="30" height="8" rx="4" fill="#00D5FF" />
                <circle cx="54" cy="4" r="4" fill="#D9D9D9" />
              </svg>

              <div
                className="p-6 gap-2.5 w-auto w-card h-card  bg-[rgba(240,235,248,0.22)] border border-[rgba(255,255,255,0.1)] rounded-[24px] shadow-[inset_0_0_10px_rgba(185,225,254,0.25)]"
                style={{ backdropFilter: 'blur(14.5px)' }}
              >
                <div className="text-white">Shortlisted Companies</div>
                <div>
                  <span className="text-white text-[20px] font-[600] ">40</span>{' '}
                  <span className="text-white text-sm font-[500] ">
                    for 3 weeks
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-800 bg-opacity-20  pt-[32px] flex flex-col justify-between  about-card rounded-[16px] border border-[#424242] justify-self-center">
            <div className="px-[32px]">
              <div className="bg-blue-500 bg-opacity-20 w-[48px] h-[48px] flex justify-center items-center border border-[#155EEF] rounded-lg mb-14">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.9998 22.7501C11.3998 22.7501 10.8098 22.6101 10.3298 22.3401L5.59977 19.6101C3.63977 18.2901 3.50977 18.0501 3.50977 15.9801V11.0201C3.50977 8.95006 3.63977 8.71006 5.55977 7.42006L10.3398 4.66006C11.2898 4.11006 12.7198 4.11006 13.6698 4.66006L18.3998 7.39006C20.3598 8.71006 20.4898 8.95006 20.4898 11.0201V15.9801C20.4898 18.0501 20.3598 18.2901 18.4398 19.5801L13.6598 22.3401C13.1898 22.6201 12.5898 22.7501 11.9998 22.7501ZM11.9998 5.75006C11.6598 5.75006 11.3198 5.82006 11.0798 5.96006L6.34977 8.69006C5.00977 9.60006 5.00977 9.60006 5.00977 11.0201V15.9801C5.00977 17.4001 5.00977 17.4001 6.39977 18.3401L11.0898 21.0401C11.5698 21.3201 12.4398 21.3201 12.9198 21.0401L17.6498 18.3101C18.9898 17.4001 18.9898 17.4001 18.9898 15.9801V11.0201C18.9898 9.60006 18.9898 9.60006 17.5998 8.66006L12.9098 5.96006C12.6798 5.82006 12.3398 5.75006 11.9998 5.75006Z"
                    fill="white"
                  />
                  <path
                    d="M17.5 8.38C17.09 8.38 16.75 8.04 16.75 7.63V5C16.75 3.42 16.08 2.75 14.5 2.75H9.5C7.92 2.75 7.25 3.42 7.25 5V7.56C7.25 7.97 6.91 8.31 6.5 8.31C6.09 8.31 5.75 7.98 5.75 7.56V5C5.75 2.58 7.08 1.25 9.5 1.25H14.5C16.92 1.25 18.25 2.58 18.25 5V7.63C18.25 8.04 17.91 8.38 17.5 8.38Z"
                    fill="white"
                  />
                  <path
                    d="M13.6302 17.6301C13.4202 17.6301 13.2002 17.5901 12.9802 17.5001L12.0002 17.1201L11.0202 17.5101C10.4902 17.7201 9.95024 17.6701 9.55024 17.3801C9.15024 17.0901 8.94024 16.5901 8.97024 16.0201L9.03024 14.9701L8.36024 14.1601C8.00024 13.7101 7.88024 13.1901 8.04024 12.7101C8.19024 12.2401 8.60024 11.8801 9.15024 11.7401L10.1702 11.4801L10.7402 10.5901C11.3502 9.63012 12.6602 9.63012 13.2702 10.5901L13.8402 11.4801L14.8602 11.7401C15.4102 11.8801 15.8202 12.2401 15.9702 12.7101C16.1202 13.1801 16.0002 13.7101 15.6402 14.1501L14.9702 14.9601L15.0302 16.0101C15.0602 16.5801 14.8502 17.0701 14.4502 17.3701C14.2102 17.5401 13.9302 17.6301 13.6302 17.6301ZM9.52024 13.2001L10.1902 14.0101C10.4202 14.2801 10.5502 14.7101 10.5302 15.0601L10.4702 16.1101L11.4502 15.7201C11.7802 15.5901 12.2202 15.5901 12.5502 15.7201L13.5302 16.1101L13.4702 15.0601C13.4502 14.7101 13.5802 14.2901 13.8102 14.0101L14.4802 13.2001L13.4602 12.9401C13.1202 12.8501 12.7602 12.5901 12.5702 12.3001L12.0102 11.4201L11.4402 12.3001C11.2502 12.6001 10.8902 12.8601 10.5502 12.9501L9.52024 13.2001Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p className="text-[20px] font-semibold leading-[30px]  text-[#fff] h-[80px]">
                Core Program Acceptance
                <p className="text-[#98A2B3] text-[16px] font-normal leading-[24px]">
                  {cohort?.end_date}
                </p>
              </p>
              <p className="text-[#98A2B3] text-[16px] font-normal leading-[24px] mb-5">
                The final 20 startups enter the core program, gaining focused
                mentorship, extensive resources, access to investors, and
                significantly enhanced chances of securing funding. This stage
                is pivotal in transforming their AI innovations into
                market-ready solutions.
              </p>
            </div>
            <div
              className="flex items-end justify-between w-full h-[178px] rounded-bl-[16px] rounded-br-[16px] p-[32px] "
              style={{
                background:
                  'linear-gradient(94.28deg, #6864F7 2.93%, #155EEF 98.73%)                  ',
              }}
            >
              <svg
                width="58"
                height="8"
                viewBox="0 0 58 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="4" cy="4" r="4" fill="#D9D9D9" />
                <circle cx="18" cy="4" r="4" fill="#D9D9D9" />
                <rect x="28" width="30" height="8" rx="4" fill="#00D5FF" />
              </svg>

              <div
                className="p-6 gap-2.5 w-auto w-card h-card  rounded-[24px] bg-[rgba(248,235,245,0.22)] border border-[rgba(255,255,255,0.1)] shadow-[inset_0_0_10px_rgba(185,225,254,0.25)]"
                style={{ backdropFilter: 'blur(14.5px)' }}
              >
                <div className="text-white">Core Program </div>
                <div>
                  <span className="text-white text-[20px] font-[600] ">20</span>{' '}
                  <span className="text-white text-sm font-[500] ">
                    for 12 weeks
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
